import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_RETTEKODER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/rettekoder`;
export const POST_RETTEKODE_URL = `${ILEGGELSE_SERVICE_BASE_URL}/rettekoder`;
export const PUT_RETTEKODE_URL = (id) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/rettekoder/${id}`;
